import axios from "axios";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiHeader } from "./ApiHeader";
import { CMS_LIST_SUCCESS, CMS_UPDATE_SUCCESS, CMS_VIEW_SUCCESS, IS_LOADING, CATEGORY_LIST_SUCCESS, CATEGORY_UPDATE_SUCCESS, CATEGORY_UPDATE_ERROR, FAQ_UPDATE_SUCCESS, FAQ_UPDATE_ERROR, FAQ_LIST_SUCCESS, FAQ_CREATE_ERROR, FAQ_CREATE_SUCCESS} from "./Type";
import { apiVersion } from "src/utils/apiVersion";


export const GetCMSList = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/cms/list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CMS_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
         })
}

export const ResetGetCMSList = () => async (dispatch) => {
    dispatch({
        type: CMS_LIST_SUCCESS,
        payload: {}
    })
}

export const GetCMSView = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/cms/view`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CMS_VIEW_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("user list error", errors);
        })
}

export const UpdateCMSView = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .put(`${baseUrlPostGres()}/admin/${apiVersion.v1}/cms/update`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CMS_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("user list error", errors);
        })
}

export const ResetUpdateCMSView = () => async (dispatch) => {
    dispatch({
        type: CMS_UPDATE_SUCCESS,
        payload: {}
    })
}

export const GetCategoryList = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/category/list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CATEGORY_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
         })
}

export const ResetGetCategoryList = () => async (dispatch) => {
    dispatch({
        type: CATEGORY_LIST_SUCCESS,
        payload: {}
    })
}


export const CreateCategoryAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/category/create`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CATEGORY_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: CATEGORY_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetCreateCategoryAction = () => async (dispatch) => {
    dispatch({
        type: CATEGORY_UPDATE_SUCCESS,
        payload: {}
    })
}

export const GetFaqList = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/faq/list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: FAQ_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
         })
}

export const ResetGetFaqList = () => async (dispatch) => {
    dispatch({
        type: FAQ_LIST_SUCCESS,
        payload: {}
    })
}

export const CreateFaqAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/faq/create`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: FAQ_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: FAQ_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetCreateFaqAction = () => async (dispatch) => {
    dispatch({
        type: FAQ_UPDATE_SUCCESS,
        payload: {}
    })
}

export const UpdateFaqAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .put(`${baseUrlPostGres()}/admin/${apiVersion.v1}/faq/update`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: FAQ_CREATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: FAQ_CREATE_ERROR,
                payload: errors
            })
        })
}

export const ResetUpdateFaqAction = () => async (dispatch) => {
    dispatch({
        type: FAQ_CREATE_SUCCESS,
        payload: {}
    })
}